import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environement';
import { AbonnementEnfantDetailsDTO } from '../../../models/abonnement.model';

@Injectable({ providedIn: 'root' })
export class AbonnementApiService {

  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  private getAuthHeaders(): HttpHeaders {
    if (isPlatformBrowser(this.platformId)) {
      const token = localStorage.getItem('presence');
      return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
    }
    return new HttpHeaders();
  }

  getAbonnementDetailsByEnfant(enfantId: number): Observable<AbonnementEnfantDetailsDTO> {
    return this.http.get<AbonnementEnfantDetailsDTO>(
      `${this.baseUrl}/api/parent/enfants/${enfantId}/abonnement-details`,
      { headers: this.getAuthHeaders() }
    );
  }

  getAbonnementStatus(): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/api/parent/abonnement/status`,
      { headers: this.getAuthHeaders() }
    );
  }

  getMontant(): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/api/parent/abonnement/montant`,
      { headers: this.getAuthHeaders() }
    );
  }

  initiateFlouciPayment(): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/api/parent/abonnement/pay/flouci`,
      {},
      { headers: this.getAuthHeaders() }
    );
  }

  uploadReceipt(file: File, methode: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('methode', methode);

    return this.http.post<any>(
      `${this.baseUrl}/api/parent/abonnement/pay/receipt`,
      formData,
      { headers: this.getAuthHeaders().delete('Content-Type') }
    );
  }

  getPaymentHistory(): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseUrl}/api/parent/abonnement/payments`,
      { headers: this.getAuthHeaders() }
    );
  }
}
